/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/15/20
Valve Hours component: called in irrigation_form
**********************************************************/
import { NumberInput, HiddenInput } from '../../components/inputs';
import { calculateTotalGallons } from '../irrigation_utils';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  valves: PropTypes.array,
  handleValveHours: PropTypes.func
};

const ValveHours = ({ valves, handleValveHours, edit }) => {
  function _onChange(hours) {
    if (Number(hours.value) === 0) hours.style.backgroundColor = '#ffffff';
    if (Number(hours.value) > 0) {
      hours.style.backgroundColor = '#bbdefb';
      hours.style.fontWeight = 'bold';
      hours.style.textAlign = 'center';
      hours.style.color = '#424242';
    }
    return;
  }
  return (
    <div className="utils-container">
      <div className="card z-depth-2">
        <div className="card-content">
          <span className="card-title blue-text"><u>Valve Hours</u></span>
          <div className="row">
            {
              valves.map((v) => (
                <div key={v.id} className="col s6 m3 l3 xl3">
                  <div className="col s4 m4 l4 xl4">
                    <span className="irr-meter-label z-depth-3">{ v.valveNo }</span>
                  </div>
                  <div className="col s8 m8 l8 xl8">
                    <NumberInput id={`valve${v.id}-hours`} name={`valve-${v.id}`} min={0} max={100}  
                      onChange={(e) => { _onChange(document.getElementById(`valve${v.id}-hours`));
                        handleValveHours({
                          v: {
                            valveId: v.id,
                            engineId: v.engineId,
                            meterId: v.meterId,
                            hours: e.target.value,
                            totalGal: calculateTotalGallons({ hours: e.target.value, galPerMinute: v.galPerMinute})
                          },
                          edit
                        })
                      }}
                    />
                  </div>
                  <HiddenInput id={`valve${v.id}-engineId`} value={v.engineId} />
                  <HiddenInput id={`valve${v.id}-meterId`} value={v.meterId} />
                  <HiddenInput id={`valve${v.id}-valveId`} value={v.id} />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}


ValveHours.propTypes = propTypes;
export default ValveHours;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/irrigation_valve_hours.js